/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Segmented } from "antd";
import { MoonOutlined, SunOutlined } from "@ant-design/icons";
import Button from "../components/ui/Button";
import Icon from "../components/ui/Icon";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../api/user-authentication";
import { useThemeMode } from "../context/ThemeContext";

export function LoginPage({ appMeta, onLogin }) {
  // const [email, setEmail] = useState(appMeta.demoCredentials.email);
  const [email, setEmail] = useState("");
  // const [password, setPassword] = useState(appMeta.demoCredentials.password);
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { mode, setMode } = useThemeMode();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    // const demoEmail = appMeta.demoCredentials.email.trim().toLowerCase();
    // const demoPassword = appMeta.demoCredentials.password.trim();
    // const normalizedEmail = email.trim().toLowerCase();
    // const normalizedPassword = password.trim();

    // const isValidEmail = normalizedEmail === demoEmail;
    // const isValidPassword = normalizedPassword === demoPassword;

    // if (isValidEmail && isValidPassword) {
    //   setError("");
    //   onLogin?.();
    //   navigate("/dashboard");
    //   return;
    // }

    // setError("Invalid credentials. Use the demo email and password below.");
    setError("");
    setIsLoading(true);
    try {
      const { user, expires_in } = await loginUser({
        email: email.trim(),
        password: password.trim(),
      });
      console.debug("Login successful:", user);
      console.debug("Token expires in:", expires_in, "seconds");
      localStorage.setItem("user", JSON.stringify(user));

      onLogin?.(user);
      navigate("/dashboard");
    } catch (error) {
      console.error("Login error:", error);
      const status = error.response.status;
      const message =
        error.response.data?.message || error.response.data?.detail;
      setError(message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-shell">
      <div className="login-chrome">
        <img
          src="/fw_logo.png"
          alt={`${appMeta.productName} logo`}
          className="login-brand-logo"
        />
        <Segmented
          size="middle"
          value={mode}
          onChange={setMode}
          className="topbar-segmented login-theme-toggle"
          options={[
            { label: <SunOutlined />, value: "light" },
            { label: <MoonOutlined />, value: "black" },
          ]}
        />
      </div>

      <form className="login-card" onSubmit={handleSubmit}>
        <div className="login-header">
          <div className="login-hero-icon">
            <Icon name="shield" size={24} />
          </div>
          <h1 className="login-title">{appMeta.productName}</h1>
          <div className="login-subtitle">Sign in to your account</div>
        </div>

        <div className="field">
          <span className="field-label">Email Address</span>
          <div className="input-with-icon">
            <Icon name="mail" className="field-icon" size={18} />
            <input
              className="input"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="admin@example.com"
              autoComplete="username"
              required
              disabled={isLoading}
            />
          </div>
        </div>

        <div className="field">
          <span className="field-label">Password</span>
          <div className="input-with-icon">
            <Icon name="lock" className="field-icon" size={18} />
            <input
              className="input"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              required
              disabled={isLoading}
            />
          </div>
        </div>

        <Button
          type="submit"
          variant="primary"
          className="btn-lg btn-block"
          loading={isLoading}
        >
          {isLoading ? "Signing in..." : "Sign In"}
        </Button>

        {error && <div className="login-error">{error}</div>}

      </form>
    </div>
  );
}

export default LoginPage;
